/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
(function($){
  console.log('welcome friend')

setInterval(function(){
        if ($('a.mini-cart__product-title').text().includes('<br>')) {
          var minicartTitle = $('a.mini-cart__product-title').text().replace('<br>',' ');
          $('a.mini-cart__product-title').html(minicartTitle);          
        }

		$.getJSON('/cart.js', function(cart){ 
			// var result = cart.item_count;
          var result = cart.total_price / 100;
			// console.log(result);
          if ( result >= 1000 ) {
            // console.log('gotta do free shipping')
            $('.free-shipping-amount-left, .free-shipping-amount-text').hide()
            $('.free-shiping-activated').show()
          } else {
            // console.log('gotta change the value')
            var text = 1000 - result
            $('.free-shipping-amount-left').text(text.toFixed(0))
            $('.free-shipping-amount-left, .free-shipping-amount-text').show()
            $('.free-shiping-activated').hide()
          }
		});
	},1000);
  
})(jQuery);
